import React, { useEffect, useMemo } from "react";
import { Footer } from "../../components/FooterV2";
import { Header } from "../../components/Header";
import "./styles.less";
import { Helmet } from "react-helmet";
import { HomePageBanner } from "../../blocks/home-page-banner";
import { HomePageGuard } from "../../blocks/home-page-guard";
import { HomePageProduct } from "../../blocks/home-page-product";
import { HomePageSolution } from "../../blocks/home-page-solution";
import { HomePageCustomer } from "../../blocks/home-page-customer";
import { HomePageMultiply } from "../../blocks/home-page-multiply";
import { HomeTryOn } from "../../blocks/home-try-on";
import { useTranslation } from "react-i18next";
// import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/swiper.less";

export const HomePage = () => {
  const { t } = useTranslation();
  useEffect(() => {
    new Swiper(".home-banner-swiper", {
      spaceBetween: 24,
      slidesPerView: 6,
      // slidesPerView:
      //   JSON.parse(sessionStorage.getItem("windowWidth")) > 1200 ? 12 : 4,
      // slidesPerView: "auto",
      loop: true,
      // centeredSlides: true,
      autoplay: {
        delay: 2500,
        disableOnInteraction: false,
      },
    });
  }, []);

  const titles = useMemo(() => {
    return [
      {
        title: "Authing",
        title2: t("homePage.banner.item1.title2"),
        subtitle: t("homePage.banner.item1.subtitle"),
        subtitleSmall: t("homePage.banner.subtitleSmall"),
        bg: "home-1-bg-e-1.jpg",
      },
      {
        title: t("homePage.banner.item2.title"),
        title2: t("homePage.banner.item2.title2"),
        subtitle: t("homePage.banner.item2.subtitle"),
        subtitleSmall: t("homePage.banner.subtitleSmall"),
        bg: "home-banner-002.png",
        link: "https://www.authing.cn/blog/474?keyword=gartner&page=1",
        linkName: t("common.button.detail"),
      },
      {
        title: t("homePage.banner.item3.title"),
        title2: t("homePage.banner.item3.title2"),
        subtitle: t("homePage.banner.item3.subtitle"),
        subtitleSmall: t("homePage.banner.subtitleSmall"),
        bg: "home-banner-00001.png",
        link: "https://authing.csdn.net/",
        linkName: t("common.button.community"),
      },

      {
        title: t("homePage.banner.item4.title"),
        title2: t("homePage.banner.item4.title2"),
        subtitle: t("homePage.banner.item4.subtitle"),
        subtitleSmall: t("homePage.banner.subtitleSmall"),
        bg: "home-banner-04.png",
        link: "https://www.authing.co/blog/538?utm_source=banner4",
        linkName: t("common.button.review"),
      },
    ];
  }, [t]);

  return (
    <div className="home-page">
      <Helmet>
        <title>{t("homePage.title")}</title>
      </Helmet>

      <Header mode="dark" />
      <HomePageBanner banners={titles} showBrandContainer />
      <HomePageGuard />
      <HomePageProduct />
      <HomePageSolution />
      <HomePageCustomer />
      <HomePageMultiply />
      <HomeTryOn hasBg />

      <Footer />
    </div>
  );
};
